import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ApiServiceService} from '../../../../api-service.service';
import {ConfirmPopUpFinzyFlexSkeletonData} from './skeleton/confirm-pop-up-finzy-flex-skeleton.component';

export interface ConfirmPopUpFinzyFlexData extends ConfirmPopUpFinzyFlexSkeletonData {
    message: string;
}

@Component({
    selector: 'app-comfirm-pop-up-finzy-flex',
    templateUrl: 'confirm-pop-up-finzy-flex.component.html',
    providers: [ApiServiceService]
})
export class ConfirmPopUpFinzyFlexComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public popUpData: ConfirmPopUpFinzyFlexData) {
    }
}
